export default "__VITE_ASSET__0f362e38__"